export const addContactToCustomerIO = async ({
  email,
  first_name = '',
  last_name = '',
  country_code,
}: {
  email: string;
  first_name?: string;
  last_name?: string;
  country_code?: string;
}) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_MEDUSA_URL}/store/custom/newsletter`,
      {
        method: 'POST',
        body: JSON.stringify({ email, first_name, last_name, country_code }),
        headers: {
          'Content-Type': 'application/json',
          'x-publishable-api-key': `${process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY}`,
        },
      }
    );

    if (!response.ok) {
      return false;
    }

    const res = await response.json().catch(() => {
      return { success: false, message: 'Failed to subscribe' };
    });
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
